import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ModalProvider } from "./contexts/ModalContext";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { Landing } from "./pages/Landing";
import { TermsOfService } from "./pages/TermsOfService";
import { SmsPolicy } from "./pages/SmsPolicy";
// import { Campaign } from "./pages/Campaign"; // old campaign page
import { CampaignReturn } from "./pages/CampaignReturn";
import { Checkout } from "./pages/Checkout";
import { Dashboard } from "./pages/Dashboard";
import { ResetPassword } from "./pages/ResetPassword";
import { NotFound } from "./pages/NotFound";
import { AdminLogin } from "./pages/AdminLogin";
import { Admin } from "./pages/Admin";
import { CampaignV2 } from "./pages/CampaignV2";

localStorage.setItem("onboarding", "false");

export const App = () => {
  return (
    <ChakraProvider>
      <ModalProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/tos" element={<TermsOfService />} />
            <Route path="/sms-policy" element={<SmsPolicy />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Setup Dashboard as a parent route */}
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/campaign/:id/checkout" element={<Checkout />} />
            <Route path="/campaign/:id/return" element={<CampaignReturn />} />
            <Route path="/campaign/:id" element={<CampaignV2 />} />
            {/* Admin routes */}
            <Route
              path="/admin"
              element={
                <AdminAuthProvider>
                  <AdminLogin />
                </AdminAuthProvider>
              }
            />
            <Route
              path="/admin/builder"
              element={
                <AdminAuthProvider>
                  <Admin />
                </AdminAuthProvider>
              }
            />
            {/* 404 catch-all route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ModalProvider>
    </ChakraProvider>
  );
};
